import { ROUTES } from '@/lib/constants/routes';

/** sessionStorage key for return path after login (set before navigating to `/`). */
export const POST_LOGIN_REDIRECT_STORAGE_KEY = 'supplierPortalPostLoginPath';

/**
 * Returns a safe in-app path for navigation after login, or the default booking-requests route.
 * Rejects open-redirect patterns (e.g. protocol-relative URLs).
 */
export function normalizeAppReturnPath(raw: string | null | undefined): string {
  const fallback = ROUTES.BOOKING_REQUESTS;
  if (!raw?.trim()) {
    return fallback;
  }
  let path = raw.trim();
  try {
    path = decodeURIComponent(path);
  } catch {
    return fallback;
  }
  path = path.trim();
  if (!path.startsWith('/') || path.startsWith('//')) {
    return fallback;
  }
  if (path.includes('://')) {
    return fallback;
  }
  return path;
}
